
import { supabaseWorker } from '@/integrations/supabase/workerClient';

export interface PassportDepartment {
  id: string;
  code: string;
  name: string;
  region?: string;
}

export async function fetchPassportUnits(searchCode: string): Promise<PassportDepartment[]> {
  if (!searchCode || searchCode.length < 2) {
    return [];
  }

  try {
    console.log('[fetchPassportUnits] Searching for:', searchCode);
    // Наш fetchClient не поддерживает .or(); выполняем несколько запросов последовательно и объединяем
    const queryText = searchCode.trim();
    const pattern = `%${queryText}%`;
    const digits = (queryText || '').replace(/\D/g, '');
    const formatted = digits.length >= 6 ? `${digits.slice(0, 3)}-${digits.slice(3, 6)}` : queryText;

    // Сначала — точные совпадения (с дефисом и без), чтобы они имели приоритет в выдаче
    const collected: PassportDepartment[] = [];

    if (digits.length >= 6) {
      const byExactDash = await supabaseWorker
        .from('passport_departments')
        .select('id, code, name, region')
        .eq('code', formatted)
        .limit(10);
      {
        const arr = (byExactDash as unknown as { data: PassportDepartment[] | null }).data;
        if (Array.isArray(arr)) collected.push(...arr);
      }

      const byExactDigits = await supabaseWorker
        .from('passport_departments')
        .select('id, code, name, region')
        .eq('code', digits)
        .limit(10);
      {
        const arr = (byExactDigits as unknown as { data: PassportDepartment[] | null }).data;
        if (Array.isArray(arr)) collected.push(...arr);
      }
    }

    // Далее — частичные совпадения по коду и названию
    const byCodeRes = await supabaseWorker
      .from('passport_departments')
      .select('id, code, name, region')
      .ilike('code', pattern)
      .limit(10);
    {
      const arr = (byCodeRes as unknown as { data: PassportDepartment[] | null }).data;
      if (Array.isArray(arr)) collected.push(...arr);
    }

    const byNameRes = await supabaseWorker
      .from('passport_departments')
      .select('id, code, name, region')
      .ilike('name', pattern)
      .limit(10);
    {
      const arr = (byNameRes as unknown as { data: PassportDepartment[] | null }).data;
      if (Array.isArray(arr)) collected.push(...arr);
    }

    // Дедуп по id с сохранением приоритета (первые добавленные — точные совпадения)
    const uniqueMap = new Map<string, PassportDepartment>();
    for (const item of collected) {
      if (item && item.id && !uniqueMap.has(item.id)) uniqueMap.set(item.id, item);
    }
    const result = Array.from(uniqueMap.values()).slice(0, 10);

    console.log('[fetchPassportUnits] Found departments (unique):', result.length);
    return result;
  } catch (error) {
    console.error('[fetchPassportUnits] Error:', error);
    // Возвращаем пустой массив, чтобы UI корректно отобразил отсутствие данных/ошибку
    return [];
  }
}

// Удалены мок-данные: используем реальные данные из БД
